import React from 'react'
import { getAccessToken } from 'web/src/shared/Auth'
import { useUnmountEffect } from '@mote/helpers'
import { BASE_URL } from '@mote/helpers/constants'

const NETWORK_TIMEOUT = 12 * 1000

const INITIAL_STATE = {
  data: null,
  loading: true,
  error: null,
  fetched: false
}

const URL = `${BASE_URL}i/settings`

export const usePreferredLocaleMutation = () => {
  const [state, setState] = React.useState(INITIAL_STATE)
  const timeoutRef = React.useRef(null)
  const abortControllerRef = React.useRef(null)

  async function updatePreferredLocale(preferredLocale) {
    abortControllerRef.current = new AbortController()
    timeoutRef.current = setTimeout(() => {
      abortControllerRef.current.abort()
    }, NETWORK_TIMEOUT)

    try {
      const response = await fetch(URL, {
        headers: {
          'Content-Type': 'application/json'
        },
        signal: abortControllerRef.current.signal,
        method: 'post',
        body: JSON.stringify({
          mode: 'set',
          preferredLocale,
          accessToken: getAccessToken()
        })
      })

      const data = await response.json()
      setState({ data, loading: false, error: null, fetched: true })
    } catch (err) {
      if (err.name !== 'AbortError') {
        setState({ data: null, loading: false, error: err, fetched: true })
      }
    }

    clearTimeout(timeoutRef.current)
    abortControllerRef.current = null
  }

  useUnmountEffect(() => {
    clearTimeout(timeoutRef.current)
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
    }
  }, [])

  return { ...state, mutate: updatePreferredLocale }
}
